export default [
  {
    label: '基本信息',
    options: [
      { label: '客户名称', lang: 'mobile.sjykif', field: 'customerName', type: 'AInput', attrs: {} },
      { label: '客户办公地', lang: 'mobile.dpkz0b', field: 'customerOffice', type: 'CosCascader', attrs: {} },
      { label: '客户类型', lang: 'mobile.tjn5gr', field: 'customerType', type: 'ASelect', attrs: {} },
      { label: '标签', lang: 'mobile.20cuou', field: 'customerTag', type: 'ASelect', attrs: {} },
      { label: '备注', lang: 'mobile.7bhxw2', field: 'remark', type: 'ATextarea', attrs: {} }
    ]
  },
  {
    label: '联系人信息',
    options: [
      { label: '联系人名称', lang: 'common.contactName', field: 'contact.name', type: 'AInput', attrs: {} },
      { label: '性别', lang: 'common.sex', field: 'contact.sex', type: 'ASelect', attrs: {} },
      { label: '角色', lang: 'mobile.w6ctth', field: 'contact.jobRole', type: 'ASelect', attrs: {} },
      { label: '手机号', lang: 'common.mobile', field: 'contact.mobile', type: 'AInput', attrs: {} },
      { label: '邮箱', lang: 'common.email', field: 'contact.email', type: 'AInput', attrs: {} },
      { label: '微信号', lang: 'mobile.vlqnxv', field: 'contact.wechat', type: 'AInput', attrs: {} },
      { label: 'QQ号', lang: 'mobile.row6xl', field: 'contact.qq', type: 'AInput', attrs: {} },
      { label: '固定电话', lang: 'mobile.js7gnj', field: 'contact.tel', type: 'AInput', attrs: {} },
      { label: '联系人备注', lang: 'common.contactRemark', field: 'contact.remark', type: 'ATextarea', attrs: {} }
    ]
  },
  {
    label: '业务信息',
    options: [
      {
        label: '产品货型',
        lang: 'clue.businessCargoType',
        field: 'business.cargoType',
        type: 'ParamCodesSelect',
        paramCode: 'product',
        attrs: {}
      },
      {
        label: '销售平台',
        lang: 'clue.销售平台',
        field: 'business.salePlatform',
        type: 'ParamCodesSelect',
        paramCode: 'channel',
        attrs: {}
      },
      {
        label: '需求海外仓',
        lang: 'clue.warehouses',
        field: 'business.warehouse',
        type: 'ParamCodesSelect',
        paramCode: 'demand',
        attrs: {}
      },
      { label: '发货地', lang: 'mobile.cq6wxe', field: 'business.shipAddress', type: 'AInput', attrs: {} },
      {
        label: '销售品类',
        lang: 'clue.salesCategory',
        field: 'business.salesCategory',
        type: 'ParamCodesSelect',
        paramCode: 'category',
        attrs: {}
      },
      {
        label: '跨境月销售额',
        lang: 'mobile.ew7r19',
        field: 'business.monthSales',
        type: 'ParamCodesSelect',
        paramCode: 'monthly',
        attrs: {}
      },
      { label: '目的国家', lang: 'mobile.fu24mh', field: 'business.destinationCountry', type: 'AInput', attrs: {} },
      // { label: '需要的服务', field: 'business.requiredServices', type: 'AInput', attrs: {} },
      {
        label: '服务需求',
        lang: 'clue.serviceDemand',
        field: 'business.serviceNeeds',
        type: 'ParamCodesSelect',
        paramCode: 'service',
        attrs: {}
      },
      {
        label: '客户类别',
        lang: 'clue.customerCategory',
        field: 'business.customerCategory',
        type: 'ParamCodesSelect',
        paramCode: 'customerCategory',
        attrs: {}
      }
      // {
      //   label: '是否已有合作',
      //   field: 'business.cooperation',
      //   type: 'ParamCodesSelect',
      //   paramCode: 'zbu_existing_cooperation',
      //   attrs: {}
      // }
    ]
  }
]

export const ofbuTemplateFields = [
  {
    label: '基本信息',
    lang: 'common.baseTabs',
    options: [
      { label: '客户名称', lang: 'mobile.sjykif', field: 'customerName', type: 'AInput', attrs: {} },
      { label: '来源渠道', lang: 'clue.clueChannel', field: 'channel', type: 'ParamCodesSelect', paramCode: 'clueChannel', attrs: {} },
      { label: '客户办公地', lang: 'mobile.dpkz0b', field: 'customerOffice', type: 'CosCascader', attrs: {} },
      { label: '客户官网', lang: 'clue.officialWeb', field: 'customerWebsite', type: 'AInput', attrs: {} },
      { label: '客户注册邮箱', lang: 'clue.regEmail', field: 'registerEmail', type: 'AInput', attrs: {} },
      { label: '客户详细地址', lang: 'clue.customerAddress', field: 'customerAddress', type: 'AInput', attrs: {} },
      { label: '预计月销售额', lang: 'clue.estAveRevenue', field: 'business.annualSales', type: 'AInput', attrs: {} },
      { label: '客户业务类型', lang: 'clue.clientType', field: 'clientType', type: 'ParamCodesSelect', paramCode: 'clientType', attrs: {} },
      { label: '销售渠道', lang: 'clue.salesChannel', field: 'business.salesChannel', type: 'ParamCodesSelect', paramCode: 'salesChannel', attrs: {} },
    ]
  },
  {
    label: '联系人信息',
    lang: 'common.concatInfo',
    options: [
      { label: '联系人名称', lang: 'common.contactName', field: 'contact.name', type: 'AInput', attrs: {} },
      { label: '性别', lang: 'common.sex', field: 'contact.sex', type: 'ASelect', attrs: {} },
      { label: '手机号', lang: 'common.mobile', field: 'contact.mobile', type: 'AInput', attrs: {} },
      { label: 'Skype', field: 'contact.skype', type: 'AInput', attrs: {} },
      { label: '邮箱', lang: 'common.email', field: 'contact.email', type: 'AInput', attrs: {} },
    ]
  },
  {
    label: '业务需求',
    lang: 'custom.业务需求',
    options: [
      {
        label: '业务类型',
        lang: 'clue.业务类型',
        field: 'business.businessTypeSelect',
        type: 'ParamCodesSelect',
        paramCode: 'businessTypeSelect',
        attrs: {}
      },
      {
        label: '销售平台',
        lang: 'clue.销售平台',
        field: 'business.salePlatform',
        type: 'ParamCodesSelect',
        paramCode: 'channel',
        attrs: {}
      },
      { label: '发货量(月)', lang: 'clue.发货量(月)', field: 'business.shipments', type: 'ParamCodesSelect', paramCode: 'shipments', attrs: {} },
      {
        label: '产品分类',
        lang: 'clue.产品分类',
        field: 'business.salesCategory',
        type: 'ParamCodesSelect',
        paramCode: 'category',
        attrs: {}
      },
      {
        label: '产品尺寸',
        lang: 'clue.产品尺寸',
        field: 'business.cargoType',
        type: 'ParamCodesSelect',
        paramCode: 'product',
        attrs: {}
      },
      {
        label: '区域仓',
        lang: 'clue.区域仓',
        field: 'business.regionalWarehouse',
        type: 'ParamCodesSelect',
        paramCode: 'regionalWarehouse',
        attrs: {}
      }
    ]
  }
]
